import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { InventoryMasterPage } from '@/features/inventory'

export const Route = createFileRoute('/_authenticated/inventory/master')({
  component: () => (
    <RequirePermission permission='inventory_master.read'>
      <InventoryMasterPage />
    </RequirePermission>
  ),
})
